import { render, staticRenderFns } from "./UgcEdit.vue?vue&type=template&id=e34f99e0"
import script from "./UgcEdit.vue?vue&type=script&lang=js"
export * from "./UgcEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports